/* Kunzul home: reveal animations, scrollers (drag + arrows) */
(function () {
  if (window.__khHome) return;
  window.__khHome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var RV = [
    '.kh-head', '.kh-tile', '.kh-camp__main', '.kh-camp__row > *', '.kh-camp__text',
    '.kh-scroller > *', '.kh-arrows-row', '.kh-foot__col', '.kh-foot__social', '.kh-foot__bottom'
  ].join(',');
  var io = null;

  function stagger(el) {
    var p = el.parentElement;
    if (!p) return 0;
    var i = Array.prototype.indexOf.call(p.children, el);
    return Math.min(Math.max(i, 0), 5) * 80;
  }

  function markReveal(scope) {
    if (reduce || design || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('kh-anim');
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('kh-in');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    Array.prototype.forEach.call((scope || document).querySelectorAll(RV), function (el) {
      if (!el.closest('.kh') || el.classList.contains('kh-rv')) return;
      el.classList.add('kh-rv');
      el.style.setProperty('--kh-d', stagger(el) + 'ms');
      io.observe(el);
    });
    Array.prototype.forEach.call((scope || document).querySelectorAll('.kh-hero'), function (h) {
      if (h.dataset.khObs) return;
      h.dataset.khObs = '1';
      io.observe(h);
    });
  }

  function updateArrows(sc) {
    var id = sc.id;
    if (!id) return;
    var max = sc.scrollWidth - sc.clientWidth - 2;
    document.querySelectorAll('[data-kh-scroll="' + id + '"]').forEach(function (b) {
      var dir = parseInt(b.getAttribute('data-dir'), 10) || 1;
      b.disabled = dir < 0 ? sc.scrollLeft <= 2 : sc.scrollLeft >= max;
    });
  }

  function initScroller(sc) {
    if (sc.dataset.khBound) return;
    sc.dataset.khBound = '1';
    var t = null;
    sc.addEventListener('scroll', function () {
      if (t) cancelAnimationFrame(t);
      t = requestAnimationFrame(function () { updateArrows(sc); });
    }, { passive: true });
    updateArrows(sc);

    if (!finePointer) return;
    var down = false, startX = 0, startLeft = 0, moved = 0;
    sc.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = 0; startX = e.clientX; startLeft = sc.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4 && !sc.classList.contains('is-dragging')) sc.classList.add('is-dragging');
      moved = Math.max(moved, Math.abs(dx));
      if (sc.classList.contains('is-dragging')) sc.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (sc.classList.contains('is-dragging')) {
        var cards = sc.children;
        var w = cards.length ? cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(sc).columnGap || 0) : sc.clientWidth;
        var target = Math.round(sc.scrollLeft / w) * w;
        sc.classList.remove('is-dragging');
        sc.scrollTo({ left: target, behavior: 'smooth' });
      }
    });
    sc.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kh-scroll]');
    if (!b) return;
    var sc = document.getElementById(b.getAttribute('data-kh-scroll'));
    if (!sc) return;
    var dir = parseInt(b.getAttribute('data-dir'), 10) || 1;
    var first = sc.children[0];
    var step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(sc).columnGap || 0) : sc.clientWidth * 0.8;
    var perView = Math.max(1, Math.floor(sc.clientWidth / step));
    sc.scrollBy({ left: dir * step * perView, behavior: 'smooth' });
  });

  function initScrollers(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.kh-scroller'), initScroller);
  }

  function boot() {
    markReveal(document);
    initScrollers(document);
    window.addEventListener('load', function () {
      if (window.kcLenis && typeof window.kcLenis.resize === 'function') window.kcLenis.resize();
      initScrollers(document);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { markReveal(e.target); initScrollers(e.target); });
})();